module.exports = __webpack_public_path__ + "static/media/changes-banner-mobile.e84f5f5d.jpg";